var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8C4.73478 8 4.48043 8.10536 4.29289 8.29289C4.10536 8.48043 4 8.73478 4 9V18C4 18.2652 4.10536 18.5196 4.29289 18.7071C4.48043 18.8946 4.73478 19 5 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8946 18.5196 20 18.2652 20 18V9C20 8.73478 19.8946 8.48043 19.7071 8.29289C19.5196 8.10536 19.2652 8 19 8H5ZM2.87868 6.87868C3.44129 6.31607 4.20435 6 5 6H19C19.7957 6 20.5587 6.31607 21.1213 6.87868C21.6839 7.44129 22 8.20435 22 9V18C22 18.7957 21.6839 19.5587 21.1213 20.1213C20.5587 20.6839 19.7957 21 19 21H5C4.20435 21 3.44129 20.6839 2.87868 20.1213C2.31607 19.5587 2 18.7956 2 18V9C2 8.20435 2.31607 7.44129 2.87868 6.87868Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7V5C7 4.20435 7.31607 3.44129 7.87868 2.87868C8.44129 2.31607 9.20435 2 10 2H14C14.7956 2 15.5587 2.31607 16.1213 2.87868C16.6839 3.44129 17 4.20435 17 5V7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7V5C15 4.73478 14.8946 4.48043 14.7071 4.29289C14.5196 4.10536 14.2652 4 14 4H10Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11C12.5523 11 13 11.4477 13 12V12.01C13 12.5623 12.5523 13.01 12 13.01C11.4477 13.01 11 12.5623 11 12.01V12C11 11.4477 11.4477 11 12 11Z",
    fill: "#A3A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10719 12.5502C2.35572 12.057 2.95701 11.8587 3.45022 12.1072C6.10222 13.4435 9.03054 14.1396 12.0002 14.1396C14.9699 14.1396 17.8982 13.4435 20.5502 12.1072C21.0434 11.8587 21.6447 12.057 21.8932 12.5502C22.1418 13.0434 21.9434 13.6447 21.4502 13.8932C18.5191 15.3703 15.2825 16.1396 12.0002 16.1396C8.71795 16.1396 5.48138 15.3703 2.55022 13.8932C2.05701 13.6447 1.85866 13.0434 2.10719 12.5502Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/BriefcaseIcon.c6deeb9076367170a8de3950f43e58a6.svg";
export { ForwardRef as ReactComponent };